import { HubSpotConflictDto } from 'api/HubSpot/types/HubSpotConflictDto'
import { ScreeningResultsDto } from 'api/WorldCheck/Types/ScreeningResultsDto'

import { ApiClient } from './ApiClient'

export class HubSpotApiClient {
  constructor(private apiClient: ApiClient) {}

  syncHubSpotForClients: (data: { clientIds: string[] }) => Promise<ScreeningResultsDto> = (
    data
  ) => {
    return this.apiClient.post(`hubspot/hubspot/contacts/clients/init`, data)
  }
  checkHubspotConflict: (email: string) => Promise<HubSpotConflictDto> = (email) => {
    return this.apiClient.get(`hubspot/hubspot/email-conflict/${email}`)
  }
  syncHubSpotForLeads: (data: { leadIds: string[] }) => Promise<void> = (data) => {
    return this.apiClient.post(`hubspot/hubspot/contacts/leads/init`, data)
  }
}
